import React, { Component } from 'react';
import $ from 'jquery';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
import PDeal from './modules/pdeals_list.js';
import { Link } from 'react-router';

// import  SubHeaderMain  from './../Common/SubHeaderMain.js';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class Web_OffersDetails extends Component {
    constructor(props){
    super(props);
    this.state={
      feedsList: [],
      fulldata:[],
      feedbrands: [],
      feed_sub_cat:[],
      feedcat: [],
      todata:'',
      types:[],
      tid : this.props.params.Tid,
      lod: false,
      type: this.props.params.Type,
      dtype: this.props.params.DType,
      data_type: this.props.params.DType,
      ofr_type: this.props.params.Offer,
      bread: '',
      activeMenu: '',
      selected: '',
      loading: false,
      loadmore_number: 2,
      loadmore_status: 0,
      set_type:'',
      next_page:'',
      loading_gif:false,
      h1_desc:'',
    };
    localStorage.setItem('d_type',this.props.params.Dtype);
    this.loadMoreDeals=this.loadMoreDeals.bind(this);
    this.getDeviceId=this.getDeviceId.bind(this);
    this.getBrands_Categories=this.getBrands_Categories.bind(this);
  }
  getBrands_Categories()
  {
      var data1={from: 'desktop_web',type:4};
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getbrands_categoires',
          dataType:'json',
          data: {req:data2},
          success: function(data)
          {
              this.setState({
                  feedbrands:data.brands,
                  feedcat:data.categories,
              });
          }.bind(this),
          error: function(err)
          {
            
          }
      });
  }
  getTypes()
  {
      var data1={from: 'desktop_web'};
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getTypes',
          dataType:'json',
          data: {req:data2},
          success: function(data)
          {
            this.setState({
                types:data.types,
            });
          }.bind(this),
          error: function(err){
          // console.log("Error"+err);
          }
      })
  }
  getDeviceId()
  {
    if(localStorage.user_id)
    {
        var user_id=localStorage.user_id;
    }
    else
    {
      user_id=0;
    }
    var data1={from: 'desktop_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
    var data2=JSON.stringify(data1);
    $.ajax({
        method: 'POST',
        url: baseUrl+'getDeviceId',
        dataType: 'json',
        data:{req: data2},
        success: function(data)
        {
          
        },
        error: function(err)
        {
        }
    });
  }
  loadMoreDeals(num,type,tid,dtype)
  {
    this.setState({
      loading_gif:true,
    });
    var getfunc="";
    var data1="";
    var data2="";
    var uid =0;
    if(localStorage.user_id)
    {
       uid=localStorage.getItem('user_id')
    }
    else
    {
       uid=0;
    }
    if(type ===">="){
      data1={from :'desktop_web',uid:uid,page:num,type:dtype,limit:20};
      data2=JSON.stringify(data1);
      getfunc="getNewsearch";
    }
    
    var products="";
    $.ajax({
          method: 'POST',
          url: baseUrl+getfunc,
          dataType:'json',
          data: {req:data2},
          success: function(data){
              this.setState({
                  offer: data,
                  todata: data,
                  loading:true,
                  title:data.cat_name,
                  desc:data.cat_desc,
                  selected  : data.cat_name,
                  loadmore_status:data.load_more,
                  set_type: data.set_type,
                  next_page:data.next_page,
                  loading_gif:false,
              });
            this.setState({ 
                feedsList: this.state.feedsList.concat(data.result),
            });
          }.bind(this),
          error:function(err)
          {
            // console.log(err);
            this.setState({
              loading_gif:false,
            });
          }
      });
    return products;
  }
  componentDidMount()
  {
      localStorage.removeItem('w_r_s_dt');
    localStorage.removeItem('w_r_e_coupon_dt');
    localStorage.removeItem('w_r_e_s_dt');
    localStorage.removeItem('web_mycart');
    localStorage.removeItem('w_r_enq_seller_page');
    localStorage.removeItem('w_r_p_dt');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('web_ofr_page');
    localStorage.removeItem('profile');
    localStorage.removeItem('myaquacash');
    localStorage.removeItem('web_share_earn');
    localStorage.removeItem('checkout');
    localStorage.removeItem('order_details');
    localStorage.removeItem('myorders');
    localStorage.removeItem('w_r_p_deals');
    localStorage.removeItem('seed');
    localStorage.removeItem('nauplii');
    localStorage.removeItem('subdeals');
    localStorage.removeItem('shipping');
    localStorage.removeItem('notifications');
    localStorage.removeItem('web_quickcart');
    localStorage.removeItem('view_rating');
    localStorage.removeItem('w_modal_seed');
    localStorage.removeItem('w_r_seed_deals');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('w_modal_details');
   
    localStorage.removeItem('give_rating');
    localStorage.removeItem('pprice');
    localStorage.removeItem('sprice');
    localStorage.removeItem('seed_id');
    localStorage.removeItem('h_type');
    localStorage.removeItem('web_pro_ofr_dtls');
    localStorage.removeItem('web_wishlist');
    localStorage.removeItem('web_brand_details');

    localStorage.removeItem('m_r_s_dt');
    localStorage.removeItem('m_r_e_coupon_dt');
    localStorage.removeItem('m_r_e_s_dt');
    localStorage.removeItem('mob_mycart');
    localStorage.removeItem('m_r_enq_seller_page');
    localStorage.removeItem('m_r_p_dt');
    localStorage.removeItem('m_r_e_p_dt');
    localStorage.removeItem('ofr_page');
    localStorage.removeItem('pro_ofr_dtls');

    localStorage.removeItem('share_earn');
    localStorage.removeItem('my_orders');
    localStorage.removeItem('m_r_p_deals');
    localStorage.removeItem('mob_quickcart');
    localStorage.removeItem('partner_deals');
      if(screen.width < 800 )
      {
          window.location.href="/offers/deals/"+this.props.params.Tid+"/"+this.props.params.Type+"/"+this.props.params.DType;
      }
      if(!localStorage.token && !localStorage.user_id)
      {
          localStorage.setItem('offers','/web/offers/deals/'+this.props.params.Tid+'/'+this.props.params.Type+'/'+this.props.params.DType);    
      }
      
      this.getBrands_Categories();
      this.getDeviceId();
      var uid =0;
      if(localStorage.user_id)
      {
         uid=localStorage.getItem('user_id')
      }
      else
      {
         uid=0;
      }
      $(window).scrollTop(0);
      var self = this;
      setTimeout(() => {self.setState({lod: true}); }, 15000);
      localStorage.setItem('d_type',this.props.params.Dtype);
      this.getTypes();
      var data1={from:'desktop_web',uid:uid,discount:this.props.params.Tid,discount_type:this.props.params.DType,discount_opr: this.props.params.Type}
      var data2=JSON.stringify(data1);
      var get_function = 'getNewsearch';        
      $.ajax({
          method:'POST',
          url:baseUrl+get_function,
          dataType:'json',
          data:{req:data2},
          success: function(data1)
          {
            if(data1.products)
            {
              this.setState({
                  feedsList:data1.products,
                  offer: data1,
                  todata: data1,
                  loading:true,
                   h1_desc:data1.product_name,
              });
            }
            else
            {
              this.setState({
                  feedsList:data1.result,
                  offer: data1,
                  todata: data1,
                  loading:true,
              });
            }
          }.bind(this),
          error: function(err)
          {
            // console.log("Error"+err);
          }
      });
  }
  render(){
       // console.log(this.state.feedsList);
    //     var products=this.state.feedsList.map(function(product,index){ 
          
    //       return(
                
    //             <div className="col-md-3 col-sm-3 col-xs-3 eq_cls">
    //             {product.pid ?
    //                 <div className="itm_lst_grd">
    //                  {product.dealcount >= 2 ? 
    //                 <Link key={product.index} to={"/web/subdeals/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.dtype+"/"+product.url_brand_name+"/"+product.pid)}>
    //                         <div className="itm_img">
    //                                 <img className="itm_img" alt="Deals" src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
    //                         </div>
    //                         <h2>{product.title}</h2>
    //                         <h5>{product.brand_name}</h5>
    //                         {product.dealcount >=2 ? <h3>{product.dealcount} deals available</h3> : ''}
    //                         <div className="clr">&nbsp;</div>
    //                         {product.over_rate >=1 ? <h6  className="w_star_rate"><i><img src={baseAssets+'images/web_imgs/star_filled.png'} width="17px" role="presentation"/></i>{product.over_rate}</h6>: <h6 className="w_nostar_rate"><i><img src={baseAssets+'images/web_imgs/star_gray.png'} width="17px" role="presentation"/></i></h6>}
    //                         {product.count >0 ? <h6 className="views_eye"><i><img src={baseAssets+'images/web_imgs/eye.png'} width="17px" role="presentation"/></i> {product.count} {product.count >1 ? 'Views' : 'View'}</h6> : ''}
    //                         <div className="clr"></div>
    //                 </Link> :    
    //         <Link key={product.index} to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pid+"/"+product.deal_id}>
    //                     <div className="itm_img">
    //                         <img className="itm_img" alt="Deals" src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
    //                     </div>
    //                     <h2>{product.title}</h2>
    //                     <h5>{product.brand_name}</h5>
    //                    {product.pricediff ?  <h3><span>AquaCash Discount</span>&nbsp;<span>&#8377;{product.pricediff}</span></h3> : ''}
    //               {product.pricediff ==="" ? <h3>MRP &#8377; {product.mrp}</h3> : ''}
    //               <div className="clr">&nbsp;</div>
    //               {product.over_rate >=1 ? <h6  className="w_star_rate"><i><img src={baseAssets+'images/web_imgs/star_filled.png'} width="17px" role="presentation"/></i>{product.over_rate}</h6>: <h6  className="w_nostar_rate" ><i><img src={baseAssets+'images/web_imgs/star_gray.png'} width="17px" role="presentation"/></i></h6>}
    //               {product.count >0 ? <h6 className="views_eye" ><i><img src={baseAssets+'images/web_imgs/eye.png'} width="17px" role="presentation"/></i> {product.count} {product.count >1 ? 'Views' : 'View'}</h6> : ''}

    //               <div className="clr"></div>
    //         </Link>
    //          <Link className="share_btn" onClick={()=>{this.ShareFunc(product.deal_id)}}>
    //               <img src={baseAssets+'images/web_imgs/share.png'} alt="Share" />
    //             </Link>
    //             <Panel className="share_panel" collapsible expanded={this.state.open}>
    //               <FacebookShareButton url={shareUrl} quote={title} className="test_share">
    //                 <FacebookIcon size={32} round />
    //               </FacebookShareButton>
    //               <TwitterShareButton url={shareUrl} quote={title} className="test_share">
    //                 <TwitterIcon size={32} round />
    //               </TwitterShareButton>
    //               <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
    //                 <GooglePlusIcon  size={32} round />
    //               </GooglePlusShareButton>
    //             </Panel>
    //     } 
    //     </div>
    //   );
    // })
    var brands = this.state.feedbrands.map(function(brand,index){
          return(
            <li key={brand.id} id={"brand_"+brand.id} >
            {/*<li key={brand.id} id={"brand_"+brand.id} className={this.isActive(brand.category_name)} onClick={this.setFilter.bind(this, brand.category_name)}>*/}
                   {/*<Link onClick={()=>{this.test(brand.type,brand.id,brand.dtype)}} to={"/web/pdeals/"+brand.url_dtype_name+"/"+brand.url_name+"/"+brand.id+"/"+brand.type+"/"+brand.dtype}>*/}
                   <Link to={"/web/pdeals/"+brand.url_dtype_name+"/"+brand.url_name+"/"+brand.id+"/"+brand.type+"/"+brand.dtype}>
                       <span>{brand.category_name}</span>
                    </Link>
                </li>
                );
        });
    var cate = this.state.feedcat.map(function(cat,index){
            if(cat.sub.length>0)
            {
            var subs_cat = cat.sub.map(function(sub_cat,index){
                  return(
                      <li key={sub_cat.id} id={"sub_cat_"+sub_cat.id}>
                    {/*<li key={sub_cat.id} id={"sub_cat_"+sub_cat.id} className={"sub_cat_li "+this.isActive(sub_cat.category_name)} onClick={this.setFilter.bind(this, sub_cat.category_name)} >*/}
                        {/*<Link onClick={()=>{this.test(sub_cat.type,sub_cat.id,sub_cat.dtype)}} to={"/web/pdeals/"+sub_cat.url_dtype_name+"/"+sub_cat.url_name+"/"+sub_cat.id+"/"+sub_cat.type+"/"+sub_cat.dtype}>*/}
                        <Link to={"/web/pdeals/"+sub_cat.url_dtype_name+"/"+sub_cat.url_name+"/"+sub_cat.id+"/"+sub_cat.type+"/"+sub_cat.dtype}>
                            <span>{sub_cat.category_name}</span> 
                        </Link>
                      </li>
                  );
              });
              return(
                    <li key={cat.id} id={"cat_"+cat.id}>
                    {/*<li key={cat.id} id={"cat_"+cat.id} className={this.isActive(cat.category_name)} onClick={this.setFilter.bind(this, cat.category_name)}>*/}
                        <Link>
                             <span>
                            {cat.category_name}
                            </span>
                        </Link>
                        {subs_cat}
                    </li>);
               }
               else
               {
                return(
                  <li key={cat.id} id={"cat_"+cat.id}>
                {/*<li key={cat.id} id={"cat_"+cat.id} className={this.isActive(cat.category_name)} onClick={this.setFilter.bind(this, cat.category_name)}>*/}
                        {/*<Link onClick={()=>{this.test(cat.type,cat.id,cat.dtype)}} to={"/web/pdeals/"+cat.url_dtype_name+"/"+cat.url_name+"/"+cat.id+"/"+cat.type+"/"+cat.dtype}>*/}
                        <Link to={"/web/pdeals/"+cat.url_dtype_name+"/"+cat.url_name+"/"+cat.id+"/"+cat.type+"/"+cat.dtype}>
                             <span>
                            {cat.category_name}
                            </span>
                        </Link>
                    </li>);
              }
            }.bind(this) );
    var products='';
        if(this.state.feedsList.length >0){
              products = this.state.feedsList.map((product,index) => (<PDeal key={product.id} data={product} /> ));
        }

        return(
        <div className="web_deals web_pdeals_page">        
   {this.state.loading ?
        <div className="lgt_gry">
                <WebHeaderInner />
               <div className="clr">&nbsp;</div>
               <div className="clr">&nbsp;</div>
               <div className="clr">&nbsp;</div>
               <div className="clr">&nbsp;</div>
               <div className="clr">&nbsp;</div>
               <div className="clr">&nbsp;</div>
                <section className="container Dels_cntnt" style={{paddingLeft:0}}>
                    <div className="tot_pro">
                      <div className="row" style={{marginRight:'0 !important'}}>
                            <div className="col-md-3 col-sm-3">
                                <div className="filtrs_blk">
                                      <h3>Categories</h3>
                                      <ul>
                                          {cate}
                                      </ul>
                                      <h3>Brands</h3>
                                      <ul className={brands.length > 10 ? 'flt_scrl' : 'no_scrl'}>
                                          {brands}
                                      </ul>
                                </div>
                            </div>

                            <div className="pro_sec col-md-9 col-sm-9">
                              <div className="pro_sec_hdr">
                                 <h3>{this.state.h1_desc}<span>({this.state.feedsList.length} Items)</span></h3>
                              </div>
                              <div className="clr"></div>
                                <div className="row itm_lst">
                                    {this.state.loading_gif ? <i className="web_loading_gif"><img src={baseAssets+'images/loading_more.gif'} alt="Loading" /></i> : ''}
                                    {products? products : <div>{this.state.lod ? <div className="seed_no_data">No Deals Available</div> : <div className="loading_sym" style={{width:100+'%',textAlign:'center',marginTop:15+'%'}}><img src={baseAssets+'images/web_imgs/ajax-loader.gif'} alt="AquaDeals" role="presentation" /></div> }</div> }
                                </div>
                                    {this.state.loadmore_status === 1  ? <div className="web_loadmore_button" onClick={()=>{this.setState({ loadmore_number : this.state.loadmore_number+1 }); this.loadMoreDeals(this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType)}}><i className="glyphicon glyphicon-circle-arrow-down"></i>Load More Deals</div> : ''} 
                            </div>
                    </div>
                </div>
              </section>
                <div className="clr"></div>
                <WebFooter />
</div> : <div className="loading_sym" style={{width:100+'%',textAlign:'center',marginTop:20+'%'}}><img src={baseAssets+'images/web_imgs/ajax-loader1.gif'} alt="Loading Deals" role="presentation" /> </div>}</div>
        );
    }
}


    



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Feed/Web_OffersDetails.js
 **/